import { Modelo } from '@ext/index';
import * as Types from './AtributosGenerales.types';
import moment, { Moment } from 'moment';

export class IAtributosGenerales extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Articulo: string = '';
    public Ean13: string = '';
    public PesoNeto: number = 0;
    public PesoTotal: number = 0;
    public Alto: number = 0;
    public Ancho: number = 0;
    public Profundidad: number = 0;
    public MetroCubico: number = 0;


    public getJson(): any
    {
        let json: any = {};
        json.peso_neto = this.PesoNeto;
        json.peso_total = this.PesoTotal;
        json.alto = this.Alto;
        json.ancho = this.Ancho;
        json.profundidad = this.Profundidad;
        json.metro3 = this.MetroCubico;
        json.ean13 = this.Ean13;


        return json;
    }


    public set(): boolean
    {

        this.Id = !this.Json.id ? 0 : this.Json.id;
        this.Articulo = !this.Json.articulo ? '' : this.Json.articulo;
        this.PesoNeto = this.Json.peso_neto;
        this.PesoTotal = this.Json.peso_total;
        this.Alto = this.Json.alto;
        this.Ancho = this.Json.ancho;
        this.Profundidad = this.Json.profundidad;
        this.Ean13 = this.Json.ean13;


        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista
    {
        return new Vista( this );
    }
}

class Vista
{
    constructor( Model: IAtributosGenerales )
    {
        this.Model = Model;
    }

    public Model: IAtributosGenerales;
}